import template from './text-editor.html';
import controller from './text-editor.controller';

export default {
	template,
	bindings: {
		value: '<ngModel',
		disabled: '<?ngDisabled',
		readonly: '<',
		required: '<?ngRequired',
		onValueChanged: '&ngChange',
		hideToolbar: '<',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
